export const BLOG_PILLARS = [
  'GLP-1 & Metabolismo',
  'Fadiga & Energia',
  'Hormônios',
  'Dor & Inflamação',
  'Pós-Bariátrica',
  'Saúde Mental & Estresse',
  'Autoimune',
  'Institucional Habitus',
  'Soroterapia',
] as const;

export type BlogPillar = (typeof BLOG_PILLARS)[number];

export const PILLAR_COLORS: Record<string, { bg: string; text: string }> = {
  'GLP-1 & Metabolismo': { bg: 'bg-primary/10', text: 'text-primary' },
  'Fadiga & Energia': { bg: 'bg-accent/10', text: 'text-accent' },
  'Hormônios': { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-700 dark:text-purple-300' },
  'Dor & Inflamação': { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300' },
  'Pós-Bariátrica': { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300' },
  'Saúde Mental & Estresse': { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300' },
  'Autoimune': { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300' },
  'Institucional Habitus': { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300' },
  'Soroterapia': { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-700 dark:text-cyan-300' },
};
